if (!customElements.get('drawer-gifts')) {
  class CartGifts extends HTMLElement {
    constructor() {
      super();

      try {
        this.config = JSON.parse(this.dataset.config).data;
      } catch (error) {
        this.config = { add_gift_automatically: false, gifts: [] };
      }

      this.cartItems = document.querySelector('cart-items');
      this.isSyncing = false;
      this.pendingRefresh = false;

      if (!this.config || !Array.isArray(this.config.gifts)) return;

      this.config.gifts.forEach((gift) => {
        gift.price = Number(gift.price || 0) * 100;
        gift.product_id = Number(gift.product_id || 0);
      });

      // Listen to cart events
      document.addEventListener('on:cart:add', (e) => {
        if (e?.detail?.cart) {
          this.checkAddToCart(e.detail.cart);
        } else {
          this.fetchCartAndSync();
        }
      });

      if (this.cartItems) {
        this.cartItems.addEventListener('on:line-item:change', (e) => {
          if (e?.detail?.cart) {
            this.checkAddToCart(e.detail.cart);
          } else {
            this.fetchCartAndSync();
          }
        });
      }

      // Initial load
      this.fetchCartAndSync();
    }

    get checkoutBtn() {
      return document.querySelector('cart-drawer button[name="checkout"]');
    }

    getGiftMatches(cart, gift) {
      return (cart.items || []).filter((item) => {
        return (
          (Number(item.id) === gift.product_id ||
            Number(item.variant_id) === gift.product_id) &&
          item.properties &&
          item.properties.Gift === 'Free Gift'
        );
      });
    }

    async fetchCartAndSync() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        await this.checkAddToCart(cart);
      } catch (e) {
        console.error('Cart fetch error', e);
      }
    }

    async checkAddToCart(cart) {
      if (this.isSyncing || !cart) return;

      this.isSyncing = true;

      try {
        for (const gift of this.config.gifts) {
          const matches = this.getGiftMatches(cart, gift);
          const qty = matches.reduce((s, i) => s + i.quantity, 0);
          const eligible = cart.total_price >= gift.price;

          // ADD
          if (eligible && qty === 0) {
            await this.addGift(gift.product_id);
            return;
          }

          // REMOVE
          if (!eligible && qty > 0) {
            await this.removeGifts(matches);
            return;
          }

          // DEDUPE
          if (qty > 1) {
            await this.dedupe(matches);
            return;
          }
        }
      } catch (e) {
        console.error('Gift sync error', e);
      }

      this.isSyncing = false;
    }

    async addGift(variantId) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                Gift: 'Free Gift'
              }
            }
          ]
        })
      });

      await this.refresh();
    }

    async removeGifts(items) {
      const updates = {};
      items.forEach((i) => (updates[i.key] = 0));

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      await this.refresh();
    }

    async dedupe(items) {
      const updates = {};
      let keep = true;

      items.forEach((i) => {
        updates[i.key] = keep ? 1 : 0;
        keep = false;
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      await this.refresh();
    }

    async refresh() {
      if (this.pendingRefresh) return;
      this.pendingRefresh = true;

      if (this.cartItems?.refresh) {
        await this.cartItems.refresh();
      }

      this.isSyncing = false;
      this.pendingRefresh = false;
    }
  }

  customElements.define('drawer-gifts', CartGifts);
}